import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button } from '@/components/ui/daisy';
import Fieldset from '@/components/ui/daisy/fieldset';
import { useQuizAnswers } from '@/data/hook/question/answers/useQuizAnswers';
import { PlusIcon } from '@heroicons/react/24/outline';
import QuizAnswerItem from './QuizAnswerItem';

export default function QuizAnswersForm() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.answersCommon',
  });

  const {
    fields,
    error,
    handleAdd,
    handleUpdateText,
    handleUpdateMedia,
    handleToggleCorrect,
    handleDelete,
    isNewItem,
  } = useQuizAnswers();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <h3 className="text-base font-semibold text-base-content">
          {t('answersTitle')}
        </h3>
        <ConditionalRenderer condition={error?.root?.message}>
          <Fieldset.Label className="text-error">
            {error?.root?.message}
          </Fieldset.Label>
        </ConditionalRenderer>
      </div>

      <Button
        type="button"
        color="primary"
        variant="soft"
        className="self-start"
        onClick={handleAdd}
      >
        <PlusIcon className="size-3.5" />
        {t('addOption')}
      </Button>
      <div className="flex flex-col gap-4">
        {fields.map((field, index) => (
          <QuizAnswerItem
            key={field.fieldId}
            answer={field}
            initialEditing={isNewItem({ index })}
            onUpdateText={text => handleUpdateText(index, text)}
            onUpdateMedia={(file, altText) =>
              handleUpdateMedia(index, file, altText)
            }
            onToggleCorrect={() => handleToggleCorrect(index)}
            onDelete={() => handleDelete(index)}
          />
        ))}
      </div>
    </div>
  );
}
